import { Map } from "immutable";
import { createSelector } from "reselect";
import { ActivatedPriceListRecord } from "common/records/ActivatedPriceList";
import { Nullable } from "common/records";
import { RootState } from "common/reducers";
import { currentEstimateActivatedPriceListId } from "common/selectors/estimate.selectors";

export const model = "activatedPriceLists";

/**
 * Loads the byId map
 *
 * @param {RootState} state The RootState
 * @returns {Map<number, ActivatedPriceListRecord>} The byId map
 */
export const byId = (state: RootState): Map<number, ActivatedPriceListRecord> => state.getIn([model, "byId"]);

/**
 * Gets the activated price list record for the current estimate's activated_price_list_id.
 * Distinct from activatedPriceListCurrentOrg, which uses the org's price list — an estimate
 * holds a snapshot of the price list at the time it was created. Lives here (not in
 * activatedPriceList.selectors.ts) so org.selectors.ts can consume it without an import cycle.
 *
 * @param {RootState} state The RootState
 * @returns {ActivatedPriceListRecord | null}
 */
export const activatedPriceListForCurrentEstimate = createSelector(
  [currentEstimateActivatedPriceListId, byId],
  (aplId, aplById): Nullable<ActivatedPriceListRecord> => {
    if (!aplId) return null;
    return aplById.get(aplId) ?? null;
  },
);
